export default {
  computed: {
    enablePublishEntity() {
      return this.entity || 'item';
    }
  },
  methods: {
    openPublishAlert(model) {
      this.model = model;

      let publishText = model.IsPublished ? 'unpublish' : 'publish';

      this.$vs.dialog({
        type: 'confirm',
        title: `Confirmation`,
        text: `You are about to ${publishText} this ${this.enablePublishEntity}`,
        accept: this.publish
      });
    },
    async publish() {
      await this.modelEntity.publish(
          this.model.id,
          !this.model.IsPublished
      );

      this.notifySuccess(`${this.enablePublishEntity} Updated`);

      if (!this.baseRoute) {
        await this.$router.back();
      } else {
        await this.$router.push({ name: this.baseRoute + '.list' });
      }
    },
    openEnableAlert(model) {
      this.model = model;

      let enableText = model.IsEnabled ? 'disable' : 'enable';

      this.$vs.dialog({
        type: 'confirm',
        title: `Confirmation`,
        text: `You are about to ${enableText} this ${this.enablePublishEntity}`,
        accept: this.enable
      });
    },
    async enable() {
      await this.modelEntity.enable(
          this.model.id,
          !this.model.IsEnabled
      );

      this.notifySuccess(`${this.enablePublishEntity} Updated`);

      if (!this.baseRoute) {
        await this.$router.back();
      } else {
        await this.$router.push({ name: this.baseRoute + '.list' });
      }
    },
  },
};
